<template>
  <v-fade-transition>
    <wgu-module-card v-bind="$attrs" :moduleName="moduleName" :icon="icon" class="card" :width=winwidth
      :height=winheight>

      <!--<v-card-text class="onprimary--text">-->
        <v-card-text class="heightRest text-lg-body-1 text-body-2">
        <p>
          Das Internetangebot wird bereitgestellt durch die
        </p>
        <h2>Stadtentwässerungsbetriebe Köln, AöR</h2>
        <p>
          Ostmerheimer Straße 555<br />
          51109 Köln<br />
          Telefon: 0221 221-26868<br />
          Telefax: 0221 221-26770<br />
          Email:<a href="mailto:steb@steb-koeln.de" target="_blank">steb@steb-koeln.de</a><br />
          Umsatzsteueridentifikationsnummer (UStID): DE224970939
        </p>

        <h2>Vorständin:</h2>
        <p>
          Dipl.-Ing. Ulrike Franzke
        </p>

      </v-card-text>

    </wgu-module-card>
  </v-fade-transition>
</template>

<script>
// the module card is a the template for a typical Wegue module
import ModuleCard from '../../../src/components/modulecore/ModuleCard';

export default {
  name: 'wgu-impressum',
  // make sure to register the 'Mapable' mixin
  components: {
    'wgu-module-card': ModuleCard
  },
  created () {
  },
  props: {
    icon: { type: String, required: false, default: 'star' }
  },
  mounted () {
    // console.log(this.$parent.$el.offsetHeight);
  },
  computed: {
    winwidth () {
      // console.log(this.$vuetify.breakpoint.name);
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '80%';
        case 'sm': return 540;
        case 'md': return 600;
        case 'lg': return 700;
        case 'xl': return 800;
      }
      return 500;
    },
    winheight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 400
        case 'sm': return 450
        case 'md': return 530
        case 'lg': return 600
        case 'xl': return 800
      }
      return 500;
    }
  },
  // here we define variables that are used in the HTML above
  data () {
    return {
      moduleName: 'wgu-impressum'
    };
  },
  methods: {
    /**
     * This function is called once the map is bound to the application
     */
  }
};
</script>

<!-- Here we do the styling of our module -->
<style scoped>

.card {
  overflow: auto;
  left: 50% !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);  /* zentriert Fenster, bei kleinen Bildschirmen dann*/
  /*
  height: 90%;
  width: 90%;
  */
  max-width: 90%;
  max-height: 90%;
  min-width: 250px;
  min-height: 250px;
  z-index: 55 !important;

}

.v-card > :last-child {
  overflow: auto;
  height: calc(100% - 70px);
}

h1 {
  line-height: 2rem;
  margin-bottom: 0.2em;
  color: #00508c;
}

h2 {
  margin-bottom: 0.2em;
  color: #00508c;
}

h3 {
  margin-bottom: 0.2em;
  color: #00508c;
}

p {
  font-size: 1em;
  line-height: 1.5rem;
}

</style>
